<template>
    <main class="main__profile__page__wrapper">
        <div class="rlms-container group__box">
            <aside class="profile__sidebar__box">
                <div class="user__profile__detail__box">
                    <div class="profile__avatar__box">
                        <img :src="userAvatar">
                    </div>
                    <div class="profile__user__info__box">
                        <h3 class="user__name__title">{{ authStore?.user?.name }}</h3>
                        <span class="user__email">{{ userData?.email }}</span>
                        <div class="purple__trans__btn">
                            <a href="javascript:void(0)" @click="showModal = true">
                                <span class="btn__icon"><img :src="galleryIcon" alt=""></span>
                                <span class="btn__text">Change Photo</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="profile__logout__box">
                    <a class="purple__solid__btn" href="javascript:void(0);" @click.prevent="logout">
                        <span class="btn__icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13 8V5C13 3.89543 12.1046 3 11 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H11C12.1046 21 13 20.1046 13 19V16"
                                    stroke="#fff" stroke-width="1.5" stroke-linecap="round"></path>
                                <path
                                    d="M9 11.75C8.58579 11.75 8.25 12.0858 8.25 12.5C8.25 12.9142 8.58579 13.25 9 13.25L9 11.75ZM22.5303 13.0303C22.8232 12.7374 22.8232 12.2626 22.5303 11.9697L17.7574 7.1967C17.4645 6.90381 16.9896 6.90381 16.6967 7.1967C16.4038 7.48959 16.4038 7.96447 16.6967 8.25736L20.9393 12.5L16.6967 16.7426C16.4038 17.0355 16.4038 17.5104 16.6967 17.8033C16.9896 18.0962 17.4645 18.0962 17.7574 17.8033L22.5303 13.0303ZM9 13.25L22 13.25L22 11.75L9 11.75L9 13.25Z"
                                    fill="#fff"></path>
                            </svg>
                        </span>
                        <span class="btn__text">Logout</span>
                    </a>
                </div>
            </aside>
            <section class="profile__details__box__wrapper">
                <div class="profile__detail__title__box account__setting__title">
                    <h3 class="title">Account Settings</h3>
                </div>
                <div class="main__account__setting__wrapper">
                    <div class="email__address__box">
                        <label class="email__title">Email address</label>
                        <span class="email__text">Your email address is <strong>{{ userData?.email }}</strong></span>
                    </div>
                    <div class="email__address__btn">
                        <div class="purple__solid__btn">
                            <a href="javascript:void(0)" @click="showChangeEmailModal = true">Change Email Address</a>
                        </div>
                    </div>
                    <div class="sepline__divider"></div>
                    <div class="google__connectivity__option">
                        <div class="google__text__wrapper">
                            <div class="icon__box">
                                <img :src="googleIcon" alt="Google Icon" />
                            </div>
                            <div class="google__description__wrapper">
                                <label>Google Connectivity</label>
                                <span class="option__desc">Use Google for the faster login methods in your
                                    account.</span>
                            </div>
                        </div>
                        <div class="toggle__option__btn">
                            <label class="switch">
                                <input type="checkbox" id="googleConnectivity" :checked="googleConnectivity"
                                    @change="updateGoogleConnectivity($event)">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="sepline__divider"></div>
                    <div class="google__connectivity__option help__desk__option">
                        <div class="google__text__wrapper">
                            <div class="icon__box">
                                <img :src="questionIcon" alt="Question Icon" />
                            </div>
                            <div class="google__description__wrapper">
                                <label>Help Desk</label>
                                <span class="option__desc">Connect our 24/7 customer support!</span>
                            </div>
                        </div>
                        <div class="option__btn__box">
                            <div class="contact__us__btn">
                                <a target="_blank" href="https://datamakesthedifference.com/contact-us/">Contact Us</a>
                            </div>
                        </div>
                    </div>
                    <div class="sepline__divider"></div>
                    <div class="delete__my__account__wrapper">
                        <h5 class="title">Delete account</h5>
                        <div class="delete__account__desc">
                            <p>Would you like to delete your account? <br>
                                Delete your account will remove all the content associated with it.</p>
                        </div>
                        <div class="deletemyaccountbtn">
                            <a href="javascript:void(0)" @click="deleteUser">Delete My
                                Account</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <BaseModal :visible="showModal" title="Change your photo" size="medium" id="change__your__photo__popup"
            class="change__your__photo__popup" @close="showModal = false">

            <div class="short__note__info">
                <p>This will be shown on your profile and message.</p>
            </div>

            <!-- File Upload Box -->
            <label :class="['file__upload__box__wrapper']" for="fileInput" v-if="!previewImage"
                :style="{ gap: userAvatar ? '10px' : '1rem' }">
                <template v-if="userAvatar">
                    <div class="profile__photo__crop__box">
                        <div class="user__profile__img__box">
                            <img :src="userAvatar" width="120" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="upload__icon__box">
                        <img :src="fileUploadIcon" />
                    </div>
                </template>
                <div class="upload__file__text__wrapper">
                    <label for="fileInput" style="color: #725cff;">{{ userAvatar ? 'Click here to change' : `Click here
                        to upload`
                        }}</label>
                    <input type="file" id="fileInput" accept="image/*" @change="handleImageChange"
                        style="display: none;" />
                    <p>Use a square image for best results</p>
                </div>
            </label>

            <!-- Preview + Save/Reset -->
            <div class="profile__photo__crop__box" v-if="previewImage">
                <div class="user__profile__img__box" id="imagePreview" style="box-shadow:none;">
                    <img :src="previewImage" alt="Preview"
                        style="max-width: 100%; max-height: 200px; border-radius: 10px;" />
                </div>
                <div class="img__crop__control__box">
                    <div class="crop__control__options">
                        <span class="img__rotate__btn" @click="resetImage">
                            <img :src="resetIcon" />
                        </span>
                    </div>
                    <div class="crop__save__btn">
                        <button class="profile__save__btn" @click="saveImage">Save</button>
                    </div>
                </div>
            </div>
        </BaseModal>
        <BaseModal :visible="showChangeEmailModal" title="Change Email Address" size="medium"
            customClass="update__email__address__popup" @close="showChangeEmailModal = false">
            <div class="emailupdates__field__block">
                <form @submit.prevent="onSubmit" class="form__group__flex">
                    <div class="short__note__info">
                        <p>Please enter your new email address and click to Send OTP button. A One-Time Password sent to
                            your
                            new email address. Enter the One-Time Password and confirm.</p>
                    </div>
                    <div class="email__field">
                        <label>New Email Address</label>
                        <input type="email" placeholder="Enter email address" v-model="email" :disabled="showOtpModal" @input="email = $event.target.value.toLowerCase()" />
                        <span class="error__message" v-if="submitted && emailError">{{ emailError }}</span>
                    </div>
                    <div class="email__field">
                        <label>Confirm Email Address</label>
                        <input type="email" placeholder="Enter email address" v-model="confirmEmail" :disabled="showOtpModal" @input="email = $event.target.value.toLowerCase()" />
                        <span class="error__message" v-if="submitted && confirmEmailError">{{ confirmEmailError
                        }}</span>
                    </div>
                    <div class="email__field" v-if="showOtpModal">
                        <label>One-Time Password</label>
                        <div class="otp-container">
                            <div class="otp-inputs">
                                <input v-for="(digit, index) in otp" :key="index" type="password" class="otp-field"
                                    maxlength="1" v-model="otp[index]" @input="handleInput(index, $event)"
                                    @keydown.backspace="handleBackspace(index, $event)" @paste="handlePaste"
                                    ref="otpRefs" />
                            </div>

                            <div class="rlms-flex rlms-align-items-center rlms-gap-5">
                                Didn’t receive the OTP?
                                <div>
                                    <a href="javascript:void(0);" class="resend-otp-link" @click="resentOtp">Resend
                                        OTP</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #footer>
                <div class="pp-footer rlms-flex rlms-justify-between" style="padding: 0;">
                    <button class="rlms-btn rlms-btn-outline-primary p-cancel-btn" type="button" id="cancel-org-modal"
                        @click="showChangeEmailModal = false;">Cancel</button>
                    <button type="submit" class="rlms-btn rlms-btn-primary" id="save-org-btn"
                        @click="onSubmit">{{ showOtpModal ? 'Confirm' : 'Send OTP' }}</button>
                </div>
            </template>
        </BaseModal>
    </main>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue';
import galleryIcon from '@/assets/images/gallery-icon.png'
import fileUploadIcon from '@/assets/images/file-upload-icon.png'
import resetIcon from '@/assets/images/rotate-left-icon.png'
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';
import axios from '@/services/axios';
import BaseModal from '@/components/BaseModal.vue';
import { showConfirmDialog, showToast } from '@/utils/swal';
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useLoaderStore } from '@/stores/loader';
import { handleError } from '@/utils/handleError';
import confirmationIcon from '@/assets/images/confirmation.png';
import googleIcon from '@/assets/images/google-icon.png'
import questionIcon from '@/assets/images/message-question-icon.png'


const router = useRouter();
const authStore = useAuthStore();
const loader = useLoaderStore();

const submitting = ref(false);
const submitted = ref(false);
const editing = ref(false);

// change photo modal
const showModal = ref(false);
const showChangeEmailModal = ref(false);
const selectedFile = ref(null);
const previewImage = ref(null);
const userAvatar = ref(null);
const userData = ref(null);
const googleConnectivity = ref(0);

const showOtpModal = ref(false);
const otp = ref(Array(6).fill(''))
const otpRefs = ref([]);

// Define validation schema
const formSchema = yup.object({
    email: yup.string().email('Please enter a valid email.').required('Please enter your email.').test(
        'has-dot-in-domain',
        'Please enter a valid email.',
        (value) => {
            if (!value) return false;
            const domain = value.split('@')[1];
            return domain && domain.includes('.');
        }
    ),
    confirmEmail: yup
        .string()
        .oneOf([yup.ref('email'), null], 'Emails must match')
        .required('Confirm email is required'),
});

// Setup form with validation
const { handleSubmit, setErrors } = useForm({
    validationSchema: formSchema,
})

const { value: email, errorMessage: emailError } = useField('email')
const { value: confirmEmail, errorMessage: confirmEmailError } = useField('confirmEmail')
const { value: otpInput } = useField('otpInput');


const logout = async () => {
    await authStore.logout();
    router.push('/');
}

// Handle file input change
const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
        selectedFile.value = file;
        const reader = new FileReader();
        reader.onload = (event) => {
            previewImage.value = event.target.result;
        };
        reader.readAsDataURL(file);
    }
};

// Reset preview and file
const resetImage = () => {
    selectedFile.value = null;
    previewImage.value = null;
    document.getElementById('fileInput').value = '';
};

// Save Image (replace with actual API call)
const saveImage = async () => {
    if (!selectedFile.value) return;

    try {
        loader.show();

        const formData = new FormData();
        formData.append('image', selectedFile.value);

        await axios.post('/user/update-profile-pic', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        showToast({
            icon: 'success',
            title: 'Success! ',
            text: 'Your profile information has been updated.',
        });

        await fetchUser();

        editing.value = false;

        showModal.value = false;
        selectedFile.value = null;
        previewImage.value = null;
    } catch (error) {
        if (error.response?.status === 422) {
            const serverErrors = error?.response?.data?.errors || {};
            const fieldErrors = {};

            Object.keys(serverErrors).forEach(key => {
                fieldErrors[key] = serverErrors[key][0];
            });

            if (Object.keys(fieldErrors).length > 0) {
                setErrors(fieldErrors);
            } else {
                handleError(error, true);
            }
        } else {
            handleError(error);
        }
    } finally {
        submitting.value = false;
        loader.hide();
    }
};

const updateGoogleConnectivity = async (event) => {
    try {
        loader.show();

        await axios.patch('/user/update', {
            google_connectivity: event.target.checked
        });

        showToast({
            icon: 'success',
            title: 'Success! ',
            text: 'Google connectivity setting updated successfully.',
        });
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const resentOtp = async () => {
    await handleSubmit(async (values) => {
        loader.show();
        try {
            await axios.post('/user/change-email', { email: values.email });

            showToast({
                icon: 'success',
                title: 'OTP Sent!',
                text: "A 6-digit OTP has been sent to your email address.",
            });

            showOtpModal.value = true
        } catch (error) {
            handleError(error);
        } finally {
            loader.hide();
        }
    })();
}

const onSubmit = async () => {
    submitted.value = true;
    await handleSubmit(async (values) => {
        loader.show();
        submitting.value = true;

        try {
            if (showOtpModal.value) {
                await axios.post('/user/update-email', {
                    email: values.email,
                    otp: values.otpInput
                });

                showToast({
                    icon: 'success',
                    title: 'OTP Sent!',
                    text: "Email Address updated successfully!",
                });

                showChangeEmailModal.value = false;
                showOtpModal.value = false
                email.value = null;
                confirmEmail.value = null;
                otp.value = Array(6).fill('');

                fetchUser();
            } else {
                await axios.post('/user/change-email', { email: values.email });
                showToast({
                    icon: 'success',
                    title: 'OTP Sent!',
                    text: "A 6-digit OTP has been sent to your email address.",
                });

                showOtpModal.value = true
            }
        } catch (error) {
            if (error.response?.status === 422) {
                const serverErrors = error?.response?.data?.errors || {};
                const fieldErrors = {};

                Object.keys(serverErrors).forEach(key => {
                    fieldErrors[key] = serverErrors[key][0];
                });

                if (Object.keys(fieldErrors).length > 0) {
                    setErrors(fieldErrors);
                } else {
                    handleError(error, true);
                }
            } else {
                handleError(error);
            }
        } finally {
            loader.hide();
            submitting.value = false;
        }
    })();

}

const deleteUser = async () => {
    try {
        const result = await showConfirmDialog({
            title: 'Are you sure?',
            html: `<div class="short__description__wrapper">
                    <p>This action is irreversible and your account data will be permanently deleted after 30 Days</p>

                    <p><b>You will not be able to log in to your account after it is deleted.</b></p>
                </div>`,
            confirmButtonText: 'Confirm',
            imageUrl: confirmationIcon
        });

        if (result.isConfirmed) {
            loader.show();

            await axios.delete(`/user`);

            await logout();
        }
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

const fetchUser = async () => {
    try {
        loader.show();

        await authStore.fetchUser();
        const user = authStore?.userinfo;

        userAvatar.value = user?.profilePicture;
        userData.value = user;
        googleConnectivity.value = user.google_connectivity;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

// Final OTP submission
function submitOtp() {
    const fullOtp = otp.value.join('')
    otpInput.value = fullOtp;

    // onSubmit();
}

// Auto-focus next input on valid entry
function handleInput(index, event) {
    const value = event.target.value.replace(/\D/g, '') // Only digits
    otp.value[index] = value

    if (value && index < otp.value.length - 1) {
        nextTick(() => otpRefs.value[index + 1]?.focus())
    }

    // Optional auto-submit
    if (otp.value.every(d => d !== '')) {
        submitOtp()
    }
}

// Handle backspace to go to previous input
function handleBackspace(index) {
    if (otp.value[index] === '' && index > 0) {
        nextTick(() => otpRefs.value[index - 1]?.focus())
    }
}

// Handle full paste
function handlePaste(event) {
    event.preventDefault()
    const pasted = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/\D/g, '')
        .slice(0, 6)

    for (let i = 0; i < pasted.length; i++) {
        otp.value[i] = pasted[i]
    }

    nextTick(() => otpRefs.value[pasted.length - 1]?.focus())

    if (pasted.length === 6) {
        submitOtp()
    }
}

onMounted(async () => {
    fetchUser();
});
</script>
<style>
input[readonly],
select[readonly] {
    background-color: rgb(238, 238, 240);
}
</style>